import type { User } from '@patrianna/shared-patrianna-types/store/UserModule'

import ROUTES from 'config/routes.json'
import type { TypedThunk } from 'store/types'

import { onWheelSpinEnd } from '../bonusesFlow/utils'

import { actions } from './slice'

export const { initCurrencies, setActiveCurrency, setDefaultActiveCurrency, clearCurrency } = actions

export const updateCurrenciesBalance =
  (...args: Parameters<typeof actions.updateCurrenciesBalance>): TypedThunk =>
  async (dispatch, getState) => {
    await onWheelSpinEnd(getState)

    dispatch(actions.updateCurrenciesBalance(...args))
  }
const ROOMS_REGEX = /bingo\/rooms\/(.*)\/play/

const PLAY_PAGE_REGEX = new RegExp(
  `(${[ROUTES.GAMES_SLINGO, ROUTES.GAMES_SLOTS, ROUTES.BINGO_GAME_INFO, ROUTES.GAMES_TABLE].join('|')})/(.*)/play`,
)

export const defaultCurrencyHandler =
  (accountMode: User['mode'], isScEnabled: boolean, routerPath: string): TypedThunk =>
  (dispatch) => {
    // do not switch to SC on GC slot games page:
    // /slots/sun-of-egypt-2/play/ - use default GC mode even if SC allowed
    // /slots/indianas-quest/play/mobile/ - use default GC mode even if SC allowed
    if ((PLAY_PAGE_REGEX.test(routerPath) || ROOMS_REGEX.test(routerPath)) && !routerPath.includes('sweepstake')) {
      return null
    }

    // switch to SC by default
    if (accountMode === 'sweepstake_preview' || isScEnabled) {
      dispatch(setDefaultActiveCurrency({ activeCurrencyId: 'SC' }))
    }

    return null
  }
